import { LoadingSkeleton, PageGridContainer, PageGridItem, tokens } from 'ComponentLibrary'
import { Stack } from '@mui/material'

export default function ValuationOverviewLoading() {
    return (
        <PageGridContainer>
            <PageGridItem columnSpan={3} columnSpanXs={4}>
                <Stack direction="column" gap={tokens.SizingSpacing300}>
                    <Stack direction="row" gap={tokens.SizingSpacing300}>
                        <KeyValueBoxLoadingSkeleton width="394px" />
                        <KeyValueBoxLoadingSkeleton width="394px" />
                    </Stack>
                    <Stack direction="row" gap={tokens.SizingSpacing300}>
                        <KeyValueBoxLoadingSkeleton width="394px" />
                        <KeyValueBoxLoadingSkeleton width="394px" />
                    </Stack>
                </Stack>
            </PageGridItem>
            <PageGridItem columnSpan={3} columnSpanXs={4}>
                <LoadingSkeleton height="264px" sx={{ transform: 'none', borderRadius: '12px' }} />
            </PageGridItem>
            <PageGridItem columnSpan={3} columnSpanXs={4}>
                <KeyValueBoxLoadingSkeleton />
            </PageGridItem>
            <PageGridItem columnSpan={3} columnSpanXs={4}>
                <KeyValueBoxLoadingSkeleton />
            </PageGridItem>
            <PageGridItem columnSpan={6} columnSpanXs={4}>
                <LoadingSkeleton height="320px" sx={{ transform: 'none', borderRadius: '12px' }} />
            </PageGridItem>
        </PageGridContainer>
    )
}

function KeyValueBoxLoadingSkeleton({ width }: { width?: string }) {
    return <LoadingSkeleton height="120px" width={width} sx={{ transform: 'none', borderRadius: '12px' }} />
}
